import { useState, useEffect } from "react";
import { useTheme, useMediaQuery, Box, Button, Modal } from "@mui/material";
import { Download } from "@mui/icons-material";
import { QRCode } from "react-qrcode-logo";
import Loader from "../../Loader";
import { PROJECT_NAME } from "../../../config";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 250, sm: 300, md: 400 },
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  p: 1,
};

const QRCodeModal = ({ open, handleClose, value }) => {
  const theme = useTheme();

  const matchesXs = useMediaQuery(theme.breakpoints.only("xs"));
  const matchesSm = useMediaQuery(theme.breakpoints.only("sm"));

  const [logoLoaded, setLogoLoaded] = useState(false);
  const [showQRCode, setShowQRCode] = useState(false);

  const qrCodeSize =
    (matchesXs ? style.width.xs : matchesSm ? style.width.sm : style.width.md) -
    20;

  const handleImageLoad = () => setLogoLoaded(true);

  useEffect(() => {
    if (logoLoaded) {
      const timer = setTimeout(() => {
        // TODO: think how good is it
        setShowQRCode(true);
      }, 500);
      return () => clearTimeout(timer); // Clean up the timeout on component unmount or update
    }
  }, [logoLoaded]);

  const download = () => {
    const canvas = document.getElementById("link-qrcode");
    if (canvas) {
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      let downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `${PROJECT_NAME.toLowerCase()}-qrcode.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="QR code"
      aria-describedby="QR code for shortened link"
    >
      <Box
        sx={{
          ...style,
          border:
            theme.palette.mode === "dark"
              ? "2px solid #1e2229"
              : "2px solid #AAB4BE",
        }}
      >
        <img
          src="/apple-touch-icon.png"
          alt="logo"
          style={{ display: "none" }}
          onLoad={handleImageLoad} // Set logoLoaded to true when the image is loaded
        />
        {!logoLoaded || !showQRCode ? (
          <Loader />
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Box>
              <QRCode
                logoImage="/apple-touch-icon.png"
                id="link-qrcode"
                size={qrCodeSize}
                removeQrCodeBehindLogo={true}
                logoOpacity={1}
                logoPadding={1}
                value={value}
                qrStyle="dots"
                eyeRadius={10}
                logoPaddingStyle="circle"
                ecLevel="Q"
              />
            </Box>
            <Box>
              <Button
                variant="outlined"
                sx={{
                  width: "100%",
                  textTransform: "none",
                  fontWeight: "bold",
                  borderRadius: "30px",
                }}
                endIcon={<Download />}
                onClick={download}
              >
                Download
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default QRCodeModal;
